var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.491,
    height: 16.52,
    viewBox: "0 0 16.491 16.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nodes",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28634",
    "data-name": "Path 28634",
    d: "M-2116.94-1076.48h-9.982a3.1,3.1,0,0,1-.455-.147,1.44,1.44,0,0,1-.833-1.394q0-4.323,0-8.646v-4.791a1.411,1.411,0,0,1,.6-1.251,3.735,3.735,0,0,1,.686-.291h8.147a1.952,1.952,0,0,1,1.066.613q.75.734,1.516,1.444a1.643,1.643,0,0,1,.543,1.275c-.007,1.462,0,2.924,0,4.386v.2l.125-.142c.405-.48.807-.963,1.216-1.44a1.436,1.436,0,0,1,1.242-.554,1.435,1.435,0,0,1,1.147.732,3.157,3.157,0,0,1,.2.519v.387a2.074,2.074,0,0,1-.447.875q-1.7,2-3.38,4.014a.461.461,0,0,0-.1.27c-.007.805,0,1.611,0,2.417a1.4,1.4,0,0,1-.6,1.233,3.765,3.765,0,0,1-.691.291Zm-2.576-15.545c-.045,0-.076-.006-.107-.006h-7.1a.486.486,0,0,0-.389.148.486.486,0,0,0-.132.394v13.5a.49.49,0,0,0,.14.4.489.489,0,0,0,.4.141h9.546a.491.491,0,0,0,.4-.14.49.49,0,0,0,.141-.4v-1.323a.636.636,0,0,0-.008-.122c-.144.079-.27.161-.405.221-.553.245-1.11.483-1.665.726a.5.5,0,0,1-.571-.058.508.508,0,0,1-.135-.547q.207-.861.409-1.723a1.732,1.732,0,0,1,.371-.741q.954-1.124,1.9-2.256a.458.458,0,0,0,.1-.269c.006-1.624,0-3.247,0-4.871v-.177h-2.324a.5.5,0,0,1-.432-.139.5.5,0,0,1-.142-.431v-2.145Zm5.042,7.054-2.669,3.164.739.622,2.667-3.166Zm-2.252-5.131-1.815-1.736v1.736Zm2.875,4.39.738.621c.11-.132.219-.25.314-.377a.474.474,0,0,0,.107-.353.474.474,0,0,0-.178-.323.471.471,0,0,0-.662.06c-.107.113-.207.233-.317.373Zm-3.183,5.262-.728-.613c-.4.357-.33.868-.474,1.312.406-.229.916-.249,1.2-.7Z",
    transform: "translate(2128.214 1093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28635",
    "data-name": "Path 28635",
    d: "M-2075.94-947.25h-3.815a.483.483,0,0,1-.425-.184.483.483,0,0,1-.075-.457.468.468,0,0,1,.421-.324,1.444,1.444,0,0,1,.161,0h7.47c.386,0,.611.178.611.484s-.225.484-.611.484Z",
    transform: "translate(2082.218 954.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28636",
    "data-name": "Path 28636",
    d: "M-2075.97-875.232h-3.8a.484.484,0,0,1-.432-.188.484.484,0,0,1-.068-.466.472.472,0,0,1,.4-.309.768.768,0,0,1,.113,0h7.6a.751.751,0,0,1,.191.02.478.478,0,0,1,.357.493.486.486,0,0,1-.43.45,1.571,1.571,0,0,1-.177,0Z",
    transform: "translate(2082.236 884.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28637",
    "data-name": "Path 28637",
    d: "M-2077.39-1021.02h2.367a.483.483,0,0,1,.42.2.483.483,0,0,1,.061.46.48.48,0,0,1-.465.31h-4.765a.485.485,0,0,1-.433-.189.485.485,0,0,1-.067-.467.492.492,0,0,1,.5-.31Z",
    transform: "translate(2082.231 1023.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28638",
    "data-name": "Path 28638",
    d: "M-2077.4-803.254h-2.366a.483.483,0,0,1-.421-.193.483.483,0,0,1-.065-.459.482.482,0,0,1,.462-.313h4.765a.486.486,0,0,1,.43.188.486.486,0,0,1,.07.465.49.49,0,0,1-.5.314Z",
    transform: "translate(2082.22 815.869)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodesWhite);
export default __webpack_public_path__ + "static/media/nodes-white.b4859bd1a455d073b9a709aef611ea04.svg";
export { ForwardRef as ReactComponent };